import {
  Badge,
  BadgeSize,
  BadgeVariant,
  Checkbox,
  CheckboxSize
} from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import {
  CustomButtonLinkScope,
  CustomButtonLinkTarget
} from "types/landlord/address";
import { getTargetName } from "./helpers";

type TargetStatus = "pms-synced" | "has-link" | "none";

const getTargetStatus = (target: CustomButtonLinkTarget): TargetStatus => {
  if (target.pms_synced) return "pms-synced";
  if (target.has_existing_link) return "has-link";

  return "none";
};

const TargetBadge = ({ status }: { status: TargetStatus }) => {
  if (status === "pms-synced")
    return (
      <Badge
        className="shrink-0"
        size={BadgeSize.SM}
        variant={BadgeVariant.BASE}
      >
        Synced from PMS
      </Badge>
    );

  if (status === "has-link")
    return (
      <Badge
        className="shrink-0"
        size={BadgeSize.SM}
        variant={BadgeVariant.WARNING}
      >
        Has a link
      </Badge>
    );

  return null;
};

export const TargetChecklistRow = ({
  target,
  scope,
  checked,
  onToggle
}: {
  target: CustomButtonLinkTarget;
  scope: CustomButtonLinkScope;
  checked: boolean;
  onToggle: () => void;
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const status = getTargetStatus(target);

  return (
    <div
      className="flex cursor-pointer items-center justify-between gap-4 rounded-lg px-3 py-2 transition-colors hover:bg-background-900"
      onClick={onToggle}
      role="presentation"
    >
      <div className="min-w-0">
        <span onClick={(event) => event.stopPropagation()} role="presentation">
          <Checkbox
            checked={checked}
            id={`custom-button-link-target-${target.id}`}
            label={getTargetName(target, scope, dictionary)}
            onChange={onToggle}
            size={CheckboxSize.SM}
          />
        </span>
        <p className="truncate pl-6 text-sm text-content-400">
          {target.address || "No address"}
        </p>
      </div>

      <TargetBadge status={status} />
    </div>
  );
};
